import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import SiteJsonBirdsEyeViewsBirdsEyeView from './SiteJsonBirdsEyeViewsBirdsEyeView';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonBirdsEyeViews{
	constructor(props){
		const {list}=props;
		this._list = list;
	}
	getArray(){
		return this._list;
	}
	getDefault(){
		return this._list[0];
	}
	static fromJSON(jArray, configuration){
		const list = jArray.map(jObjectBirdsEyeView=>SiteJsonBirdsEyeViewsBirdsEyeView.fromJSON(jObjectBirdsEyeView, configuration));
		return new SiteJsonBirdsEyeViews({
			list:list
		});
	}
}